class JobService {
  async getAllJobs(page = 1, country, areas, limit = 10, category = "") {
      const response = await fetch(`${process.env.REACT_APP_API}/ta/jobopportunity?page=${page}${country && "&country=" + country}${areas && "&areas=" + areas}&limit=${limit}&category=${category}`, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data;
  }

  async getAllJobsByThermOrID(page = 1, therm_id) {
    const response = await fetch(`${process.env.REACT_APP_API}/ta/jobopportunity?page=${page}&therm=${therm_id}`, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data;
  }

  async getJob(id) {
    const response = await fetch(`${process.env.REACT_APP_API}/ta/jobopportunity/${id}`, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data.items;
  }

  async getAllJobsByCompany(id) {
    const response = await fetch(`${process.env.REACT_APP_API}/ta/jobopportunity/company/${id}`, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data.items;
  }
}
export default new JobService();
